// The tab's current search result list (ids only), in memory and mirrored to per-tab Session storage.

const STORAGE_KEY = "beatboxplayerapp__searchresults";
const VERSION = 1;

let current = null;

function freezeResults(results) {
  const childIds = {};
  for (const parentId of Object.keys(results.child_ids || {})) {
    childIds[parentId] = Object.freeze(results.child_ids[parentId].slice());
  }

  return Object.freeze({
    parent_ids: Object.freeze(results.parent_ids.slice()),
    child_ids: Object.freeze(childIds),
    album_ids: Object.freeze(results.album_ids.slice()),
    nested: results.nested === true,
  });
}

function writeStorage(entry) {
  try {
    if (entry === null) {
      window.sessionStorage.removeItem(STORAGE_KEY);
    } else {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(entry));
    }
  } catch (e) {
    // Storage blocked or full: the in-memory copy still serves paging in this tab.
  }
}

export default {
  STORAGE_KEY,
  VERSION,

  save({ search, results, totals }) {
    current = Object.freeze({
      v: VERSION,
      who: window.searchContext || null,
      savedAt: Date.now(),
      search: Object.freeze({ ...search }),
      view: null,
      results: freezeResults(results),
      totals: Object.freeze({ ...totals }),
    });

    writeStorage(current);

    return current;
  },

  current() {
    return current;
  },

  clear() {
    current = null;
    writeStorage(null);
  },

  /**
   * The ids for one page of the current result list, as the /tracksearch/page body.
   */
  pageRequest(page, perPage) {
    if (!current) {
      return null;
    }

    const parentIds = current.results.parent_ids.slice((page - 1) * perPage, page * perPage);
    const childIds = {};

    for (const parentId of parentIds) {
      if (current.results.child_ids[parentId]) {
        childIds[parentId] = current.results.child_ids[parentId];
      }
    }

    return {
      parent_ids: parentIds,
      child_ids: childIds,
      nested: current.results.nested,
      total: current.results.parent_ids.length,
    };
  },
};
